import {getPlayerTimeByAbsoluteTime,} from "../../../../../common/src";
import { getStreamDurationBySessions } from "../../../../../common/src/stream";

export function Counter(nameKey = 'name', countKey = 'count') {
    const items = [];
    const itemsByName = {};

    return {
        touch(name) {
            if (!itemsByName[name]) {
                itemsByName[name] = {
                    [nameKey]: name,
                    [countKey]: 0,
                };
                items.push(itemsByName[name]);
            }
            return itemsByName[name];
        },
        inc(name) {
            this.touch(name)[countKey]++;
        },
        get values() {
            return items;
        },
        get valuesSorted() {
            return items.sort((a, b) => b[countKey] - a[countKey]);
        }
    };
}

export const watchDurationKey = (duration, totalDuration) => {
    let start = Math.floor(duration / totalDuration * 10) * 10;
    if (start >= 100) {
        start = 90;
    }
    return start + '-' + (start + 10);
};

export const getWatchTime = (watches, rangeOffset, rangeDuration) => {
    return watches.reduce((duration, [timeStart, timeStop], index) => {
        if (!timeStop) {
            if (index !== watches.length - 1) {
                return duration;
            }

            timeStop = rangeOffset + rangeDuration;
        }
        if (timeStop < rangeOffset || timeStart > rangeOffset + rangeDuration) {
            return duration;
        }
        if (timeStart < rangeOffset) {
            timeStart = rangeOffset;
        }
        if (timeStop > rangeOffset + rangeDuration) {
            timeStop = rangeOffset + rangeDuration;
        }

        return duration + timeStop - timeStart;
    }, 0);
};

// export const getStreamDurationBySessions = (stream, streamDay = null) => {
//     const now = Math.round(Date.now() / 1000);
//     if (stream?.broadcastSession?.length > 0) {
//         return stream.broadcastSession.reduce((duration, {timeStart, timeStop}) => {
//             if (null !== streamDay && streamDay !== getStreamDay(stream.timeStart, timeStart)) {
//                 return duration;
//             }

//             return duration + (timeStop || now) - timeStart
//         }, 0);
//     }

//     return stream.timeStop - stream.timeStart;
// }

export const getStreamDuration = (stream, streamDay = null) => {
    if (stream.duration > 0) {
        return stream.duration;
    }

    return getStreamDurationBySessions(stream, streamDay);
};

export const getEpisodeOffset = (episode, broadcastSessions) => {
    if (episode.offset) {
        return episode.offset;
    }

    return getPlayerTimeByAbsoluteTime(episode.timeStart, broadcastSessions);
};

export const getEpisodeStop = (episode, broadcastSessions) => {
    if (episode.duration) {
        return episode.offset + episode.duration;
    }

    return getPlayerTimeByAbsoluteTime(episode.timeStop, broadcastSessions);
}

export const getEpisodeDuration = (episode, broadcastSessions) => {
    if (episode.duration) {
        return episode.duration;
    }

    let playerStart = getEpisodeOffset(episode, broadcastSessions);
    let playerStop = getEpisodeStop(episode, broadcastSessions);

    return playerStop - playerStart;
};

export const getCounterByName = (list, getName) => {
    let items = [];
    let itemByName = {};

    list.forEach((listItem) => {
        let name = getName(listItem);
        let item = itemByName[name];
        if (!item) {
            item = {
                name,
                count: 0,
            }
            items.push(item);
            itemByName[name] = item;
        }
        item.count++;
    });

    return items
        .sort((a, b) => b.count - a.count)
        ;
}

export const getHostsFromClients = (clients) => {
    return Object.values(
        clients
            .reduce((hosts, {host, referrer}) => {
                if (!hosts[host]) hosts[host] = {name: host, count: 0, page: {}};
                if (!hosts[host].page[referrer]) hosts[host].page[referrer] = {name: referrer, count: 0};

                hosts[host].count++;
                hosts[host].page[referrer].count++;

                return hosts;
            }, {})
    )
        .sort((a, b) => b.count - a.count)
        .map(host => {
            host.page = Object.values(host.page).sort((a, b) => b.count - a.count);
            return host;
        })
        ;
}

export const fillColor = (color1, color2) => ({
    linearGradient: {
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 1
    },
    stops: [
        [0, color1],
        [1, color2]
    ],
});
